import { formatCurrency, formatDate } from '../fomatter.utils'
import { BODY_FONT, splitLines, wrapText } from '../text.utils'
import type { TicketElement } from '../TicketElement'
import type { DoubleLabelOptions } from '../types'

export class DoubleLabel implements TicketElement {
  first: string
  second: string
  firstStyle?: string
  secondStyle?: string
  secondType?: 'string' | 'date' | 'currency' | ''
  lineHeight: number
  formattedSecond: string
  important?: boolean

  constructor(
    first: string,
    second: string,
    { firstStyle, secondStyle, secondType }: DoubleLabelOptions = {}
  ) {
    this.first = first
    this.second = second
    this.firstStyle = firstStyle
    this.secondStyle = secondStyle
    this.secondType = secondType
    this.lineHeight = 30
    if (secondType === 'date') {
      this.formattedSecond = formatDate(this.second)
    } else if (secondType === 'currency') {
      this.formattedSecond = formatCurrency(+this.second)
    } else {
      this.formattedSecond = String(this.second)
    }
  }

  height(ctx: CanvasRenderingContext2D, width: number): number {
    if (!this.first || !this.second) return 0
    ctx.font = this.firstStyle || `16px ${BODY_FONT}`
    const valueWidth = width - (ctx.measureText(this.first).width + 10)
    ctx.textAlign = 'right'
    return this.lineHeight * splitLines(ctx, this.formattedSecond, valueWidth).length
  }

  render(top: number, ctx: CanvasRenderingContext2D, width: number): void {
    if (!this.first || !this.second) return
    top += this.lineHeight
    ctx.font = this.firstStyle || `16px ${BODY_FONT}`
    ctx.fillStyle = 'black'
    ctx.textBaseline = 'bottom'
    ctx.textAlign = 'left'
    ctx.fillText(this.first, 0, top)
    const valueWidth = width - (ctx.measureText(this.first).width + 10)
    ctx.font = this.secondStyle || `16px ${BODY_FONT}`
    ctx.textAlign = 'right'
    if (this.important) {
      ctx.font = `bold 18px ${BODY_FONT}`
    }
    wrapText(ctx, this.formattedSecond, width, top, valueWidth)
  }
}
